import React, { useEffect,useContext } from "react";
import DashShortcutList from "./shortcut-list";
import SalesReport from "./sales-report";
import { ToolbarContext } from "../../contexts/toolbar-context";
import { useRecordModuleHistory} from "../../contexts/module-history-context";
import { useLocation } from 'react-router';
import {useGetOptionQuery} from "../../generated/graphql";
import {useUserContext} from "../../contexts/user-context";
import {Accordion, AccordionDetails, AccordionSummary, Typography} from "@mui/material";
import AccountManagerDashboard from "./account-manager-dashboard";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import NewSitesDashboard from "./new-sites-dashboard";
import { useDaybookContext } from "../../contexts/Daybook/DayBookContext";
import AccountManagerDashboardNB from "./account-manager-dashboard-NB";

const Dashboard = () => {
    const toolbarContext = useContext(ToolbarContext);
    const recordModuleHistory = useRecordModuleHistory();
    const location = useLocation();
    const intro =  useGetOptionQuery({variables:{code:'dashboard.intro'}});
    const content = (intro.data?.option)?intro.data.option.text_value:'';
    const user = useUserContext();
    useEffect(()=> {
        console.log('remember');
        recordModuleHistory('sales');
    },[recordModuleHistory,location]);

    useEffect(()=>{
        toolbarContext.setToolbar(
        {
            primary: [],
            title: 'Dashboard',
            secondary: []
        });
    },[]);
    //console.log('env is',process.env);
    //var appbuild = process.env.REACT_APP_BUILD_TIME;
    //var process = processEnv;
    //console.log('penv',process);
    const appBuild = REACT_APP_BUILD_TIME;
    const allowedUsers = [
        "Muhammad.ahmed@buildhollywood.co.uk",
        "conor@jackagency.co.uk",
        "jayne@buildhollywood.co.uk",
        "michael@buildhollywood.co.uk",
        "kevin@diabolical.co.uk",
        "emma@buildhollywood.co.uk",
        "kristela@diabolical.co.uk",
        "rebecca@diabolical.co.uk",
        "mia.baker@buildhollywood.co.uk",
        "charlotte@jack-arts.co.uk",
        "amelia@jackagency.co.uk",
        "alisha.dandridge@buildhollywood.co.uk"
    ];
    const daybook = useDaybookContext();
    
    return <div className="dashboard is-scrollable">
    <div>
        <Accordion defaultExpanded={true}>
            <AccordionSummary>Useful Links</AccordionSummary>
                <AccordionDetails>
                    <Typography variant="body1">
                    <div dangerouslySetInnerHTML={{__html:content}}></div>
                    </Typography>
                </AccordionDetails>
        </Accordion>
        {allowedUsers.includes(user.user?.email) && (
            <Accordion defaultExpanded={false}>
                <AccordionSummary>
                Account Manager Dashboard
                </AccordionSummary>
                <AccordionDetails>
                {daybook?.theme === 'daybook'
                    ? <AccountManagerDashboard />
                    : <AccountManagerDashboardNB />}
                </AccordionDetails>
            </Accordion>
        )}
        <Accordion defaultExpanded={false}>
            <AccordionSummary>New Sites &nbsp;<NotificationsActiveIcon /></AccordionSummary>
                <AccordionDetails>
                    <NewSitesDashboard />
                </AccordionDetails>
        </Accordion>
        {user.hasPermission('campaigns.view') &&
            <Accordion defaultExpanded={true}>
                <AccordionSummary>Sales Report</AccordionSummary>
                <AccordionDetails>
                    <SalesReport/>
                </AccordionDetails>
            </Accordion>
        }
        {user.hasPermission('campaigns.view') &&
            <Accordion defaultExpanded={true}>
                <AccordionSummary>My Shortcuts</AccordionSummary>
                <AccordionDetails>
                    <DashShortcutList/>
                </AccordionDetails>
            </Accordion>
        }
        <Accordion defaultExpanded={false}>
            <AccordionSummary>App</AccordionSummary>
            <AccordionDetails>
                <Typography variant="body2">
                <div>App build: {new Date(appBuild).toISOString()}</div>
                <div>Version: {REACT_APP_VERSION}</div>
                <div>Hash: {REACT_APP_COMMITHASH}</div>
                <div>Branch: {REACT_APP_BRANCH}</div>
                {/*<div>Commit time: {REACT_APP_COMMIT_TIME}</div>*/}
                </Typography>
            </AccordionDetails>
        </Accordion>
        </div></div>;
};

export default Dashboard;